// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1cZqV","title":"styles_title__nRc60"};